import rung from "rung/src/rung";
//import seed from "rung/src/seed";
import Levels from "./engine/levels";
import Tile from "./engine/tile";

class World {
  static generate(seed) {
    const world = new World(seed);
    // world.addLevel(Levels.training());
    // world.startAt("Training");
    world.addLevel(Levels.farmlet());
    world.addLevel(Levels.forest());
    world.addLevel(Levels.upperCaverns("UpperCaverns1", "Upper Caverns"));
    world.addLevel(Levels.upperCaverns("UpperCaverns2", "Upper Caverns"));
    world.addLevel(Levels.midCaverns("MidCaverns1", "Mid Caverns"));
    world.addLevel(Levels.karstChasm("MidCaverns2", "Mid Caverns"));
    world.addLevel(Levels.lowerCaverns("LowerCaverns1", "Lower Caverns"));
    world.addLevel(Levels.statuary());
    world.startAt("Farmlet");
    world.connectPortals("Farmlet", "Forest");
    world.connectPortals("Forest", "UpperCaverns1");
    world.connectPortals("UpperCaverns1", "UpperCaverns2");
    world.connectPortals("UpperCaverns2", "MidCaverns1");
    world.connectPortals("MidCaverns1", "MidCaverns2");
    world.connectPortals("MidCaverns2", "LowerCaverns1");
    world.connectPortals("LowerCaverns1", "Statuary");
    return world;
  }

  startId;
  prevLevel;

  constructor(seed) {
    this.rng = rung();
    this.levels = new Map();
  }

  startAt(id) {
    this.startId = id;
  }

  getLevel(id) {
    return this.levels.get(id);
  }

  addLevel(level) {
    this.levels.set(level.id, level);

    // if (this.prevLevel) {
    //   level.connectPortals(this.prevLevel);
    // }
    //
    // this.prevLevel = level;
  }

  connectPortals(from, to) {
    const exitFrom = this.levels.get(from);
    const entranceTo = this.levels.get(to);

    entranceTo.entrancePortalTile = Tile.portal(
      entranceTo.entrancePortalTile.name,
      entranceTo.entrancePortalTile.desc,
      exitFrom.id,
      exitFrom.portals.exit
    );

    exitFrom.exitPortalTile = Tile.portal(
      exitFrom.exitPortalTile.name,
      exitFrom.exitPortalTile.desc,
      entranceTo.id,
      entranceTo.portals.entrance
    );
  }

  spawnStartLevel() {
    const id = this.startId ? this.startId : this.levels.keys().next().value;
    return this.spawnLevel(id);
  }

  spawnLevel(id) {
    // TODO: lazy load this using RNG
    const level = this.levels.get(id);
    return level;
  }
}

export default World;
